export default __webpack_public_path__ + "images/TR.64d84f3.png";